/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientProviderType } from './RecipientProviderType';
import {
    RecipientProviderTypeFromJSON,
    RecipientProviderTypeFromJSONTyped,
    RecipientProviderTypeToJSON,
    RecipientProviderTypeToJSONTyped,
} from './RecipientProviderType';

/**
 * 
 * @export
 * @interface CreateReferralRecipientConfigRequest
 */
export interface CreateReferralRecipientConfigRequest {
    /**
     * 
     */
    sender_facility_id: number;
    /**
     * Omit to create an "other" recipient (not backed by the provider directory) — display_name and email become required in that case.
     */
    provider_id?: string;
    /**
     * Set for recipients without a provider_id to classify their facility, or send null for Other. Older clients may omit it during rollout. Directory-backed recipients get their type from the provider directory.
     */
    provider_type?: RecipientProviderType | null;
    /**
     * 
     */
    display_name?: string;
    /**
     * Required unless provider_id resolves to an internal (ExaCare) provider, in which case it may be omitted and resolved from contact_id instead.
     */
    email?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    notes?: string;
    /**
     * Provider directory contact to resolve this recipient's email from at send time. Only applicable when provider_id resolves to an internal (ExaCare) provider; the contact must be contact_type 'inbound' for that provider.
     */
    contact_id?: string;
    /**
     * Fax number to deliver referrals to via eFax, in addition to the required email address.
     */
    fax?: string;
}



/**
 * Check if a given object implements the CreateReferralRecipientConfigRequest interface.
 */
export function instanceOfCreateReferralRecipientConfigRequest(value: object): value is CreateReferralRecipientConfigRequest {
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    return true;
}

export function CreateReferralRecipientConfigRequestFromJSON(json: any): CreateReferralRecipientConfigRequest {
    return CreateReferralRecipientConfigRequestFromJSONTyped(json, false);
}

export function CreateReferralRecipientConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReferralRecipientConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sender_facility_id': json['sender_facility_id'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'provider_type': json['provider_type'] === undefined ? undefined : json['provider_type'] === null ? null : RecipientProviderTypeFromJSON(json['provider_type']),
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'fax': json['fax'] == null ? undefined : json['fax'],
    };
}

export function CreateReferralRecipientConfigRequestToJSON(json: any): CreateReferralRecipientConfigRequest {
    return CreateReferralRecipientConfigRequestToJSONTyped(json, false);
}

export function CreateReferralRecipientConfigRequestToJSONTyped(value?: CreateReferralRecipientConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sender_facility_id': value['sender_facility_id'],
        'provider_id': value['provider_id'],
        'provider_type': RecipientProviderTypeToJSON(value['provider_type']),
        'display_name': value['display_name'],
        'email': value['email'],
        'phone': value['phone'],
        'notes': value['notes'],
        'contact_id': value['contact_id'],
        'fax': value['fax'],
    };
}

